import styled from "styled-components";
import { P, P1, P2, P3 } from "./Typography";
import Row from "./Row";
import moment from 'moment';
import useFileMeta from "./useFileMeta";
import { LightButton } from "./Buttons";
import { FaFolder } from "react-icons/fa";
import { useState } from "react";
import ModalMoveDocument from "./ModalMoveDocument";
import { Container, Attribute } from "./Attribute";

export const DocumentAttributes = ({ document }) => {
    return (
        <Container>
            <P3>Attributes</P3>
            <Attribute>
                <P2>Form Name</P2>
                {document?.name}
            </Attribute>
            <Row>
                <Attribute>
                    <P2>Fillable</P2>
                    {document?.fillable ? "Yes" : "No"}
                </Attribute>
                {document?.fillable &&
                    <Attribute>
                        <P2>Days Until Finalized</P2>
                        {document?.daysUntilFinalized || "Immediately"}
                    </Attribute>
                }
            </Row>

            <Attribute>
                <P2>Summary</P2>
                {document?.summary}
            </Attribute>
        </Container>
    )
}

export const DocumentProperties = ({ document }) => {
    const fileMeta = useFileMeta(document?.pdfKey);
    const [showMoveForm, setShowMoveForm] = useState(false);

    return (

        <Container>
            <P3>Properties</P3>
            <Attribute>
                <P2>File size</P2>
                {fileMeta?.fileSize}
            </Attribute>
            <Attribute>
                <P2>Location</P2>
                <LightButton style={{ justifyContent: 'flex-start' }} onClick={() => setShowMoveForm(true)}>
                    <FaFolder />
                    {document?.folder?.name}
                </LightButton>
                <P>{document?.folder?.path}</P>
            </Attribute>
            <Row>
                <Attribute>
                    <P2>Last Modified</P2>
                    {moment(document?.updatedAt).format('MMMM D, YYYY')}
                </Attribute>
                <Attribute>
                    <P2>Modified By</P2>
                    {`${document?.updator?.firstName} ${document?.updator?.lastName}`}
                </Attribute>
            </Row>
            <Row>
                <Attribute>
                    <P2>Date Created</P2>
                    {moment(document?.createdAt).format('MMMM D, YYYY')}
                </Attribute>
                <Attribute>
                    <P2>Created By</P2>
                    {`${document?.creator?.firstName} ${document?.creator?.lastName}`}
                </Attribute>
            </Row>
            {showMoveForm && <ModalMoveDocument document={document} onClose={() => setShowMoveForm(false)} />}
        </Container>
    )

}